exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-practitioner-secondary-navbar-styles__secondaryNav {\n  position: fixed;\n  top: 0;\n  height: 100%;\n  width: 352px;\n  z-index: 9998;\n  background-color: white;\n  transition: all 0.1s;\n}\n\n.src-practitioner-secondary-navbar-styles__active {\n  transition: all ease-in-out 0.3s;\n  box-shadow: 24px 0px 24px 0px rgba(75, 78, 83, 0.16);\n}\n", ""]);

// exports
exports.locals = {
	"secondaryNav": "src-practitioner-secondary-navbar-styles__secondaryNav",
	"active": "src-practitioner-secondary-navbar-styles__active"
};